module.exports = __webpack_public_path__ + "media/src/images/icon__happy--0--dark-b46c089186380d1f7ab0035536aaa7aa.png";